import React from 'react';
import { CONTACT } from '../../data/contactDetails';
import '../ContactDetails/ContactDetails.css';

const ContactMap = () => (
  <section className="contact-map-section" aria-label="Office location map">
    <div className="contact-map-wrap">
      <iframe
        title="CodeInventiv Solutions — Jaipur Office"
        src={CONTACT.mapEmbedUrl}
        width="100%"
        height="420"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  </section>
);

export default ContactMap;
